import URL from '../helper';
import axiosCall from './interceptor';

export const getAllVariables = async (payload) => {
  const searchParam = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}getAllVariable`;
  const response = await axiosCall('get', url,searchParam);
  return response.data;
};

export const saveVariable = async payload => {
  const url = `${URL.BASE_URL}saveVariable`;
  const response = await axiosCall('post', url, payload);
  return response.data;
};

export const deleteVariable = async payload => {
  const url = `${URL.BASE_URL}deleteVariable?id=${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

export const getVariablerelations = async payload => {
  const url = `${URL.BASE_URL}variableCategoryRelations?sourceCategoryId=${payload.id}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const addVariablerelations = async payload => {
  const url = `${URL.BASE_URL}variableCategoryRelations`;
  const response = await axiosCall('post', url, payload);
  return response.data;
};

export const deleteVariablerelations = async payload => {
  const url = `${URL.BASE_URL}variableCategoryRelations/${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

export const getAllVariableRelations = async payload => {
  const searchParam = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}variableCategoryRelations`;
  let response = await axiosCall('get', url, searchParam);
  return response.data;
};

export const updateVariable = async data => {
  const url = `${URL.BASE_URL}updateVariable`;
  let response = await axiosCall('post', url, data);
  return response.data;
};

export const getAllVariableCategory = async () => {
  const url = `${URL.BASE_URL}getAllVariableCategory`;
  const response = await axiosCall('get', url);
  return response.data;
};

// Variable Category CRUD API

export const addVariableCategory = async payload => {
  const url = `${URL.BASE_URL}saveVariableCategory`;
  const response = await axiosCall('post', url, payload);
  return response.data;
};

export const deleteVariableCategory = async payload => {
  const url = `${URL.BASE_URL}deleteVariableCategory?id=${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

